import {
  getListingsApi,
  getListingApi,
  deleteListingApi,
  updateListingApi,
  deleteListingsByFilterApi,
} from './listings.api';

import { ToastUtil } from '../utils/toast.util';

export const getListingsReducers = (builder) => {
  builder
    .addCase(getListingsApi.pending, (state) => {
      state.getListingsStatus = 'pending';
      state.error = null;
    })
    .addCase(getListingsApi.fulfilled, (state, { payload }) => {
      state.getListingsStatus = 'fulfilled';
      state.listings = payload.listings;
      state.totalListings = payload.totalCount;
      state.totalPages = payload.totalPages;
      state.currentPage = payload.currentPage;
      state.error = null;
    })
    .addCase(getListingsApi.rejected, (state, action) => {
      state.getListingsStatus = 'rejected';
      state.error = action?.error?.message;
    });
};

export const getListingReducers = (builder) => {
  builder
    .addCase(getListingApi.pending, (state) => {
      state.getListingByIdStatus = 'pending';
      state.currentListing = null;
      state.error = null;
    })
    .addCase(getListingApi.fulfilled, (state, { payload }) => {
      state.getListingByIdStatus = 'fulfilled';
      state.currentListing = payload;
      state.error = null;
    })
    .addCase(getListingApi.rejected, (state, action) => {
      state.getListingByIdStatus = 'rejected';
      state.currentListing = null;
      state.error = action?.error?.message;
    });
};

export const deleteListingReducers = (builder) => {
  builder
    .addCase(deleteListingApi.pending, (state) => {
      state.deleteListingStatus = 'pending';
      state.error = null;
    })
    .addCase(deleteListingApi.fulfilled, (state, action) => {
      state.deleteListingStatus = 'fulfilled';
      const { payload } = action;
      const deletedListingId = action.meta.arg;

      if (payload.success) {
        state.listings = state.listings.filter(
          (listing) => listing._id !== deletedListingId,
        );
        state.totalListings = Math.max(0, state.totalListings - 1);
      }
      state.error = payload.message;

      ToastUtil.handleApiResponse(
        payload,
        'Listing deleted successfully',
        'Listing deletion failed',
      );
    })
    .addCase(deleteListingApi.rejected, (state, action) => {
      state.deleteListingStatus = 'rejected';
      state.error = action?.error?.message;
      ToastUtil.error(
        'Listing deletion failed',
        action?.error?.message || 'Failed to delete listing',
      );
    });
};

export const updateListingReducers = (builder) => {
  builder
    .addCase(updateListingApi.pending, (state) => {
      state.updateListingStatus = 'pending';
      state.error = null;
    })
    .addCase(updateListingApi.fulfilled, (state, { payload }) => {
      state.updateListingStatus = 'fulfilled';
      state.error = payload.message;

      ToastUtil.handleApiResponse(
        payload,
        'Listing updated successfully',
        'Listing update failed',
      );
    })
    .addCase(updateListingApi.rejected, (state, action) => {
      state.updateListingStatus = 'rejected';
      state.error = action?.error?.message;
      ToastUtil.error(
        'Listing update failed',
        action?.error?.message || 'Failed to update listing',
      );
    });
};

export const deleteListingsByFilterReducers = (builder) => {
  builder
    .addCase(deleteListingsByFilterApi.pending, (state) => {
      state.deleteListingsByFilterStatus = 'pending';
      state.error = null;
    })
    .addCase(deleteListingsByFilterApi.fulfilled, (state, action) => {
      state.deleteListingsByFilterStatus = 'fulfilled';
      const { payload } = action;
      const { storeId } = action.meta.arg;

      if (payload.success && payload.data?.deletedCount > 0) {
        // Remove all listings for the specified store from the current listings array
        if (storeId) {
          state.listings = state.listings.filter(
            (listing) => listing.store?.storeId !== storeId,
          );
          state.totalListings = Math.max(
            0,
            state.totalListings - payload.data.deletedCount,
          );

          // Recalculate total pages
          const itemsPerPage = 25; // Default limit from getListingsApi
          state.totalPages = Math.ceil(state.totalListings / itemsPerPage);
        }
      }
      state.error = payload.message;

      ToastUtil.handleApiResponse(
        payload,
        `Successfully deleted ${payload.data?.deletedCount || 0} listings`,
        'Bulk deletion failed',
      );
    })
    .addCase(deleteListingsByFilterApi.rejected, (state, action) => {
      state.deleteListingsByFilterStatus = 'rejected';
      state.error = action?.error?.message;
      ToastUtil.error(
        'Bulk deletion failed',
        action?.error?.message || 'Failed to delete listings',
      );
    });
};
